import LogoWeb from "./web";
import { LogoBlockProps } from "./types";

export function LogoWebEditor(props: LogoBlockProps) {
  return <LogoWeb {...props} />;
}
